import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';
import { ThemeService } from 'src/app/theme.service';
import { ApiService } from 'src/app/services/api.service';
import {pipe, Subject, takeUntil } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

const queryString = require('query-string');

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
    data: any;
    selectedCity1: any;
    userName = '';
    avatarUrl = '';
    items: MenuItem[] = [];
    isShowChangePassword: boolean = false;
    isShowIpClient: boolean = false;
    modelPass = {
        userLogin: '',
        userPassword: '',
        userPassCf: ''
    }

    modelIpUser = {
        ipclient: null
    }
    submitPass = false;
    submitIP = false;
    confimPassword = false;
    selectOrg: string | null = null;
    cats = [];
    isModuleDropdownOpen = false;
    isLanguageDropdownOpen = false;
    currentLanguage = 'vi';

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authService: AuthService,
        private themeService: ThemeService,
        private apiService: ApiService,
        private messageService: MessageService,
        private translate: TranslateService
    ) {
this.items = [
    {
        label: 'Đổi mật khẩu',
        icon: 'pi pi-lock',
        command: () => {
            this.isShowChangePassword = true;
        }
    },
    {
        label: 'Cấu hình IP',
        icon: 'pi pi-desktop',
        command: () => {
            this.isShowIpClient = true;
            this.getIpClientInfo();
        }
    },
    {
        label: 'Logout',
        icon: 'pi pi-sign-out',
        command: () => {
            this.logout();
        }
    }];

    }

    logout() {
        this.authService.signout();
        localStorage.removeItem('load');
        localStorage.removeItem('myColumnState');
        localStorage.removeItem('targetOrgId'); 
    }

    ngOnInit() {
        this.userName = this.authService.getUserName();
        this.getOrganize();
        this.getWebManagements();
        this.initLanguage();
    }

    initLanguage() {
        // Cấu hình ngôn ngữ hỗ trợ
        this.translate.addLangs(['vi', 'en']);
        
        const savedLang = localStorage.getItem('currentLang');
        if (savedLang) {
            try {
                // Hỗ trợ format cũ: JSON object { acceptLanguage: 'vi' }
                const langObj = JSON.parse(savedLang);
                this.currentLanguage = langObj.acceptLanguage || 'vi';
            } catch {
                // Format mới: chuỗi thuần 'vi' hoặc 'en'
                this.currentLanguage = savedLang === 'en' ? 'en' : 'vi';
            }
        } else {
            this.currentLanguage = 'vi';
        }
        
        this.translate.setDefaultLang('vi');
        this.translate.use(this.currentLanguage);
    }

    changeLanguage(lang: string) {
        this.currentLanguage = lang;                          // 1. Cập nhật state UI ngay lập tức
        localStorage.setItem('currentLang', lang);            // 2. Lưu lại để giữ sau khi reload
        this.isLanguageDropdownOpen = false;                  // 3. Reset trạng thái dropdown
        this.translate.use(lang);                             // 4. Báo cho thư viện ngx-translate đổi ngôn ngữ
    }

    update() {
    }

    delete() {
    }

    changeTheme(theme: string) {
        this.themeService.switchTheme(theme);
    }

    getOrganize() {
        this.apiService.getOrganize().subscribe(response => {
            if(response.status === 'success') {
                  this.data = response.data.map((t)=> {
                return {
                    label: t.name,
                    value: t.value
                }
                })
                const targetOrgId = localStorage.getItem('targetOrgId');
                this.selectOrg = targetOrgId ? targetOrgId : this.data[0].value;
                this.setCurrentOrganization(this.selectOrg, false);
            } else {
                this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: response.message });
            }   
        })
    }

    changeOrganization(event) {
        this.setCurrentOrganization(event.value, true);
        localStorage.setItem('targetOrgId', event.value);
        window.location.reload();
    }

    setCurrentOrganization(targetOrgId, isNotFirtLoad = false) {
        const queryParams = queryString.stringify({targetOrgId: targetOrgId});
        this.apiService.setCurrentOrganization(queryParams, null).subscribe(response => {
            if(response.status === 'success' && isNotFirtLoad) {
                this.messageService.add({ severity: 'success', summary: 'Thông báo', detail: 'Thay đổi tổ chức thành công !' });
            } else if (response.status === 'error') {
                this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: response.message });
            }
        })
    }

    checkPasswordcf() {
        if (this.modelPass.userPassword === this.modelPass.userPassCf) {
            this.confimPassword = false;
        } else {
            this.confimPassword = true;
        }
    }

    getIpClientInfo() {
        this.apiService.getIpClientInfo().subscribe(response => {
            if(response.status == 'success') {
                this.modelIpUser.ipclient = response.data.ipclient;
            } else {
                this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: response.message });
            }
        })
    }

    saveChangePass() {
        let userLogin: any = this.authService.getClaims();
        this.submitPass = true;
        if ((this.modelPass.userPassword && !this.modelPass.userPassCf) || this.confimPassword) {
            return;
        }
        this.modelPass.userLogin = userLogin.preferred_username
        const params = { ... this.modelPass };
        delete params.userPassCf;
        this.apiService.setResetPassword(params).subscribe(results => {
            if (results.status === 'success') {
                this.messageService.add({ severity: 'success', summary: 'Thông báo', detail: 'Sửa thông tin tài khoản thành công !' });
                this.isShowChangePassword = false;
                this.logout();
            }
            if (results.status === 'error') {
                this.messageService.add({ severity: 'error', summary: results.message, detail: results.data });
            }
        })
    }

    saveIP() {
        this.submitIP = true;
        if ( this.modelIpUser.ipclient == '' || !this.modelIpUser.ipclient) {
            return;
        }
        const body = {
            ipclient: this.modelIpUser.ipclient
        }
        this.apiService.setIpClientInfo(body)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((results: any)=> {
        if (results.status === 'success') {
            this.messageService.add({ severity: 'success', summary: 'Thông báo', detail: results.message || 'Thành công' });
            this.isShowIpClient = false;
            this.modelIpUser.ipclient = null;
        }
        if (results.status === 'error') {
            this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: results.message });
        }
     })
    }

    cancel() {
        this.modelIpUser.ipclient = null;
        this.isShowIpClient = false;
    }

  getWebManagements() {
    this.apiService.getWebManagements().pipe(takeUntil(this.unsubscribe$))
      .subscribe((results: any) => {
        const list = results?.data || results;
        if (list && list.length > 0) {
          this.cats = list;
        }
      });
  }

  /** Dùng SVG đã đăng ký với ng-icon khi iconClass `asset ...` hoặc `uni uni-*` (OpenSpec icon-class-map). */
  useModuleNgIcon(cat: { iconClass?: string }): boolean {
    const c = cat?.iconClass?.trim();
    if (!c) {
      return false;
    }
    return c.startsWith('asset ') || c.startsWith('uni ');
  }

  /** Tên icon cho `<ng-icon name="...">` — khớp MODULE_POPOVER_ICONS trong app.module. */
  moduleIconNgName(cat: { iconClass?: string }): string {
    const key = cat?.iconClass?.trim() ?? '';
    const map: Record<string, string> = {
      'asset asset-tong-quan': 'moduleTongQuan',
      'asset asset-danh-muc': 'moduleDanhMuc',
      'asset asset-tai-san': 'moduleTaiSan',
      'asset asset-kiem-ke': 'moduleKiemKe',
      'asset asset-quan-ly': 'moduleQuanLy',
      'uni uni-hr': 'uniHr',
      'uni uni-mg-vehicle': 'uniMgVehicle',
      'uni uni-benefit': 'uniBenefit',
      'uni uni-recruitment': 'uniRecruitment',
      'uni uni-overview': 'uniOverview',
      'uni uni-rating': 'uniRating',
      'uni uni-education': 'uniEducation',
      'uni uni-payroll': 'uniPayroll',
      'uni uni-role': 'uniRole',
    };
    return map[key] ?? 'moduleDefault';
  }

  private readonly unsubscribe$: Subject<void> = new Subject();
}
